async function openPdfFromBase64(base64: string) {
    const base64Response = await fetch(`data:application/pdf;base64,${base64}`);
    const blob = await base64Response.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url);
}

export default openPdfFromBase64;
